import { atomHelpers } from '@approvalmax/utils';
import { atom } from 'jotai';

export const fullscreenSplitViewState = atomHelpers.createAtomWithStorage<boolean>('fullscreenSplitViewState', false);

export const openSplitViewState = atom(false);
